export const flatten = (rel: string): string => rel.replace('.maternal', '-maternal').replace('.paternal', '-paternal');

export const unflatten = (rel: string): string => rel.replace('-maternal', '.maternal').replace('-paternal', '.paternal');

export default {
  flatten,
  unflatten,
};
